import { lang } from '@umu/ukit-lang';
/***
 * @file 组件异常处理基类
 */

import React from 'react';
import { Component /* , ErrorInfo */ } from 'react';

import './baseErrorBoundary.scss';

interface IProps {
    children: JSX.Element[];
}

interface IState {
    hasError: boolean;
}

export default class BaseErrorBoundary extends Component<IProps, IState> {
    public state: IState;

    constructor(props: IProps) {
        super(props);
        this.state = { hasError: false };
    }

    public componentDidCatch(/*  error: Error, errorInfo: ErrorInfo */) {
        this.setState({ hasError: true });
    }

    public render() {
        if (this.state.hasError) {
            return <div className="err-tip">{lang('组件异常，请重新加载')}</div>;
        }
        return this.props.children;
    }
}
